// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"901992b8","952":"4024ebbf"}[chunkId] + ".chunk.js";
};